import { ReferenceOption } from './types';

/**
 * Checks whether or not the given reference option is bindable to
 * a target that has the given binding direction (`bindingType`),
 * which is either null (legacy), "inbound", "outbound", "two-way" or "private".
 *
 * NOTE: This does not check the `hidden` property of the option!
 * If this is relevant, then it needs to be checked manually!
 *
 * @param {object} referenceOption a reference option object
 * @param {string} bindingType direction of the binding
 */

export default function isReferenceBindableToDirection(
  referenceOption: ReferenceOption,
  bindingType: string | null | undefined,
) {
  if (bindingType === 'inbound') {
    // Inbound target needs a readable reference
    return referenceOption.readable;
  }
  if (bindingType === 'outbound') {
    // Outbound target needs a writable reference
    return referenceOption.writable;
  }
  if (bindingType === 'two-way') {
    // Two-way target needs both readable and writable reference
    return referenceOption.readable && referenceOption.writable;
  }
  // Otherwise need either readable or writable reference
  return referenceOption.readable || referenceOption.writable;
}
